import React from 'react';
import './Button.css';

const STYLES = ['btn--primary', 'btn--outline'];
const SIZES = ['button--small', 'btn--medium', 'btn--large'];

export const Button = ({children, type, onClick, hidden, disabled, buttonStyle, buttonSize}) => {
  const checkoutButtonStyle = STYLES.includes(buttonStyle) ? buttonStyle : STYLES[0];
  const checkoutButtonSize = SIZES.includes(buttonSize) ? buttonSize : SIZES[0];


    return (
        <button
            className={`btn ${checkoutButtonStyle} ${checkoutButtonSize}`}
            onClick={onClick}
            hidden={hidden}
            disabled={disabled}
            type={type}>
                {children}
        </button>
    )
}

export default Button